import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Container,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Table
} from "reactstrap";
import { FaEdit, FaPlus } from "react-icons/fa";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import EeiServices from "../../service/eei";
import { FaDeleteLeft } from "react-icons/fa6";
import DataTable from "react-data-table-component";
import { tableCustomStyle } from "utils";

const CourseCategory = () => {
    // region data
    const [modal, setModal] = useState({
        isOpen: false,
        title: "",
        isEdit: false
    })

    const [courseCategory, setCourseCategory] = useState({
        id: 0,
        name: '',
        isActive: true
    })

    const [listCourseCategory, setListCourseCategory] = useState({
        data: [],
        statusCode: 0
    })
    // endregion data

    // region method
    async function getCourseCategory() {
        try {
            const eeiServices = new EeiServices();

            await Swal.fire({
                title: "Loading",
                async didOpen() {
                    Swal.showLoading();
                    setListCourseCategory(await eeiServices.getCourseCategory());
                    Swal.close();
                }
            });
        }
        catch (e) {
            await Swal.fire({
                icon: 'error',
                title: 'Failed to Get Course Category',
                text: e.message,
            });
        }
    }

    function resetCourseCategory() {
        setCourseCategory({
            id: 0,
            name: '',
            isActive: true
        })
    }

    async function handleSubmit() {
        try {
            const eeiService = new EeiServices();
            await eeiService.postCourseCategory(courseCategory);

            await Swal.fire({
                icon: "success",
                title: "Success Add Course Category"
            });

            resetCourseCategory();
            toggleModal()
            await getCourseCategory();
        }
        catch (e) {
            await Swal.fire({
                icon: 'error',
                title: 'Failed to Add Course Category',
                text: e.message,
            });
        }
    }

    function toggleModal() {
        setModal({
            ...modal,
            isOpen: !modal.isOpen
        })
    }

    async function handleEdit() {
        try {
            const eeiService = new EeiServices();

            await Swal.fire({
                title: "Loading",
                async didOpen() {
                    Swal.showLoading();
                    await eeiService.editCourseCategory(courseCategory);
                    Swal.close();
                }
            });

            await Swal.fire({
                icon: "success",
                title: "Success Edit Course Category"
            });

            resetCourseCategory();
            toggleModal();
            await getCourseCategory();
        }
        catch (e) {
            await Swal.fire({
                icon: 'error',
                title: 'Failed to Edit Course Category',
                text: e.message,
            });
        }
    }
    // endregion method

    useEffect(() => {
        getCourseCategory()
            .then(() => console.log(Math.random()));
    }, []);

    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
        },
        {
            name: 'Status',
            selector: row => row.is_active ? "Active" : "Inactive",
        },
        {
            name: 'Actions',
            selector: row => row.id,
            cell: row => (
                <>
                    <Button
                        color={"info"}
                        size={"sm"}
                        className={"mr-2"}
                        onClick={() => {
                            setModal({
                                title: "Edit Course Category",
                                isOpen: !modal.isOpen,
                                isEdit: true
                            })

                            setCourseCategory({
                                id: row.id,
                                name: row.name,
                                isActive: row.is_active
                            })
                        }}>
                        <FaEdit />
                    </Button>
                </>
            )
        }
    ];

    return (
        <>
            <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
                <Container className="mt-2" fluid>
                    <Row>
                        <div className="col">
                            <Card className="bg-default shadow">
                                <CardHeader className="bg-transparent border-0 d-flex justify-content-between align-items-center">
                                    <h3 className="text-white mb-0">
                                        Course Category
                                    </h3>
                                    <Button color="primary" onClick={() => {
                                        setModal({
                                            isOpen: !modal.isOpen,
                                            title: "Add Course Category",
                                            isEdit: false
                                        })
                                    }}>
                                        <FaPlus className="mr-2" />
                                        Add
                                    </Button>
                                </CardHeader>

                                <CardBody>
                                    <DataTable
                                    customStyles={tableCustomStyle}
                                    columns={columns}
                                    data={listCourseCategory.data}
                                />
                                </CardBody>
                            </Card>
                        </div>
                    </Row>
                </Container>

                <Modal
                    className="modal-dialog-centered"
                    isOpen={modal.isOpen}
                    size={"m"}
                    onClosed={resetCourseCategory}
                    toggle={toggleModal}
                >
                    <ModalHeader toggle={toggleModal}>
                        {modal.title}
                    </ModalHeader>

                    <ModalBody>
                        <FormGroup>
                            <Label for={"course-category-name"}>
                                Name
                            </Label>

                            <Input
                                id={"course-category-name"}
                                type={"text"}
                                value={courseCategory.name}
                                onChange={event => {
                                    setCourseCategory({
                                        ...courseCategory,
                                        name: event.target.value
                                    })
                                }} />
                        </FormGroup>

                        <FormGroup>
                            <Label for={"course-category-is-active"}>
                                Is Active
                            </Label>

                            <Input
                                id={"course-category-is-active"}
                                type={"select"}
                                defaultValue={courseCategory.isActive}
                                onChange={event => {
                                    setCourseCategory({
                                        ...courseCategory,
                                        isActive: event.target.value === "true"
                                    })
                                }}>
                                <option value={"true"}>True</option>
                                <option value={"false"}>False</option>
                            </Input>
                        </FormGroup>
                    </ModalBody>

                    <ModalFooter>
                        <Button color="secondary" onClick={toggleModal}>
                            Cancel
                        </Button>

                        <Button color="primary" onClick={() => {
                            modal.isEdit ? handleEdit() : handleSubmit()
                        }}>
                            {modal.isEdit ? "Update" : "Post"} Course Category
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </>
    )
}

export default CourseCategory;
